import React from "react";
import RiskBanner from "@/components/RiskBanner";

export default function StrategyPanel({
  risk, outlook, loading, strategy,
  onRiskChange, onOutlookChange, onGenerate,
}) {
  return (
    <div className="panel p-4 mb-4" data-testid="strategy-panel">
      <div className="flex flex-wrap items-end gap-3 mb-3">
        <div>
          <div className="micro-label mb-1">Risk</div>
          <select
            value={risk}
            onChange={(e) => onRiskChange(e.target.value)}
            data-testid="strat-risk"
            className="px-2 py-1 bg-[#0a0a0a] border border-[#222] text-xs font-mono-data"
          >
            <option value="conservative">Conservative</option>
            <option value="moderate">Moderate</option>
            <option value="aggressive">Aggressive</option>
          </select>
        </div>
        <div>
          <div className="micro-label mb-1">Outlook</div>
          <select
            value={outlook}
            onChange={(e) => onOutlookChange(e.target.value)}
            data-testid="strat-outlook"
            className="px-2 py-1 bg-[#0a0a0a] border border-[#222] text-xs font-mono-data"
          >
            <option value="auto">Auto (infer from momentum)</option>
            <option value="bullish">Bullish</option>
            <option value="bearish">Bearish</option>
            <option value="neutral">Neutral</option>
          </select>
        </div>
        <button
          onClick={onGenerate}
          disabled={loading}
          data-testid="strat-generate"
          className="px-4 py-1.5 bg-[#f2ce72] text-black text-xs font-mono-data uppercase tracking-widest hover:bg-white disabled:opacity-50"
        >
          {loading ? "GENERATING…" : "GENERATE STRATEGY"}
        </button>
        <div className="text-[10px] font-mono-data text-[#555]">Pro feature</div>
      </div>
      {strategy && (
        <>
          <div className="mt-3"><RiskBanner variant="strategy" /></div>
          <pre className="ai-panel p-3 text-xs whitespace-pre-wrap mt-2" data-testid="strategy-output">
            {strategy}
          </pre>
        </>
      )}
    </div>
  );
}
